import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  queueId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
};

export const cancelAiTask = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/ai-queue/cancel`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
